var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-record",on:{"click":_vm.clickEvent}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"录屏反馈","placement":"bottom"}},[_c('i',{staticClass:"iconfont"},[_vm._v("")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }